import React from 'react';
import './Resources.css';
import topImage from '../images/Resource Page top image.png';
import testimonial1 from '../images/Resource Page testimonial 1 .png';
import testimonial2 from '../images/Resource Page Testimonail 2.png';
import testimonial3 from '../images/Resource Page Testimonial 3.png';
import testimonial4 from '../images/Resource Page Testimonial 4.png';
import testimonial5 from '../images/Resource Page Testimonial 5.png';
import CTASection from '../components/CTASection';

function Resources() {
  return (
    <div className="resources-page">
      <section className="resources-hero">
        <div className="hero-content">
          <p className="hero-tagline">Zibit helps your team plan smarter, execute better, and prove results.</p>
          <h1>Insights, Guides, and Tools for Better Trade Shows</h1>
          <button className="cta-button">Get Started</button>
        </div>
      </section>

      <section className="resources-intro">
        <div className="content-container">
          <div className="intro-grid">
            <div className="intro-text">
              <h2>Built on real trade show experience</h2>
              <p>
                Zibit helps teams streamline trade show planning—from task management 
                and strategy building, to ROI reporting—all in one place.
              </p>
            </div>
            <img src={topImage} alt="Resources" className="top-image" />
          </div>
          <div className="quiz-banner">
            <p>Is your trade-show spend pulling its weight?</p>
            <p className="quiz-cta">Take our 2-minute ROI Quiz and get your score now.</p>
            <div className="quiz-link">Take Quiz 📋</div>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="content-container">
          <h2 className="testimonials-heading">What our customers say</h2>
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <img src={testimonial1} alt="Madison K." className="testimonial-image" />
              <p className="testimonial-text">
                "Before Zibit, managing our trade shows was chaotic and time-consuming. Now, everything's in 
                one place, our team finally has clear insight into how each event is performing. Game-changer!"
              </p>
            </div>
            <div className="testimonial-card">
              <img src={testimonial2} alt="Daniel M." className="testimonial-image" />
              <p className="testimonial-text">
                "Zibit took the guesswork out of ROI tracking. We can now show our executive team where we're 
                succeeding—and what needs improvement—without shuffling through spreadsheets."
              </p>
            </div>
            <div className="testimonial-card">
              <img src={testimonial3} alt="Shawn R." className="testimonial-image" />
              <p className="testimonial-text">
                "With Zibit, our team is aligned like never before. We stay on track, track our budget, and 
                provide our CEO with real-time performance updates after each show—no more last-minute panic."
              </p>
            </div>
            <div className="testimonial-card">
              <img src={testimonial4} alt="Rebecca T." className="testimonial-image" />
              <p className="testimonial-text">
                "Our entire planning process used to feel overwhelming. Zibit's streamlined approach has freed 
                us to focus on creating memorable booth experiences instead of juggling logistics."
              </p>
            </div>
            <div className="testimonial-card">
              <img src={testimonial5} alt="Tonya S." className="testimonial-image" />
              <p className="testimonial-text">
                "I love that Zibit doesn't just store data, it helps us understand it. That level of insight 
                has been justifying our trade show investments to upper management."
              </p>
            </div>
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
}

export default Resources;